module.exports = __webpack_public_path__ + "static/img/s_facial.ad31bb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_facial.jpg
// module id = 98
// module chunks = 1